import React from 'react'
import { Card, CardContent } from "./ui/card";
import { Button } from "./ui/button";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import abtimg3 from "../assets/aboutimg3.png";
import abtimg4 from "../assets/abtimg4.png"
import abtimg5 from "../assets/abtimg5.png"
const About = () => {
  
const navigate = useNavigate();

  return (
    <div>
        <section className="relative bg-gray-900 text-white py-20 px-6 md:px-12 overflow-hidden">
  {/* Background Image */}
  <div
    className="absolute inset-0 bg-cover bg-center opacity-30"
    style={{
      backgroundImage: `url('https://images.unsplash.com/photo-1558021212-51b6ecfa0db9?auto=format&fit=crop&w=1350&q=80')`,
    }}
  ></div>

  {/* Overlay Content */}
  <div className="relative z-10 max-w-5xl mx-auto text-center animate-fade-in-up">
    <h2 className="text-10xl md:text-5xl font-bold mb-6">
      About This Initiative
    </h2>
    <p className="text-lg md:text-xl leading-relaxed italic text-gray-100 max-w-3xl mx-auto">
      “Empowerment is not a gift we wait for. It's a journey we take—step by bold step.”
    </p>
    <p className="mt-6 text-gray-200 text-base md:text-lg leading-loose">
      This platform is built to give voice to stories that matter. It's a space where women from all backgrounds
      can share their experiences, find strength in each other, and build the courage to step forward. 
      We aim to encourage, uplift, and ignite a movement of change—where every voice counts.
      Whether you're raising your voice for the first time or helping others find theirs,
      this is your moment. Let’s walk forward—together.
     
    </p>
  </div>
</section>
<br /> <br/> 

       <div className="p-6 md:p-10 lg:p-20 bg-pink-50 min-h-screen space-y-10">
      <motion.h1
        className="text-4xl md:text-6xl font-bold text-center text-pink-800"
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        A Step Towards a Future That Belongs to Everyone
      </motion.h1>

      <p className="italic text-center text-pink-700 text-lg">
        "A woman with a voice is, by definition, a strong woman." – Melinda Gates
      </p>

      <div className="grid md:grid-cols-2 gap-8">
        <Card className="rounded-2xl shadow-md">
          <CardContent className="p-6 space-y-4">
            <img src={abtimg3}alt="Hopeful Girl" className="rounded-lg w-[1000px] h-[300px]" />
            <p className="font-semibold text-center text-pink-700">She dreams. We act.</p>
          </CardContent>
        </Card>

        <Card className="rounded-2xl shadow-md">
          <CardContent className="p-6 space-y-4">
            <p className="text-lg">
              I’m taking a leap—not because I have all the resources, but because I carry
              the will to <strong>change what I can</strong>. This is a deeply personal journey
              to build a global, empowered future workforce by educating, mentoring,
              and supporting those who need it the most.
            </p>
            <p className="text-lg">
              My story isn't much different from the women I wish to uplift. I've seen
              countless women in rural India sacrifice everything just to survive.
              <strong> But don’t they deserve more?</strong>
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <Card className="rounded-2xl shadow-md">
          <CardContent className="p-6 space-y-4">
            <img src={abtimg4} alt="Girl Sitting Alone" className="rounded-lg p-6 space-y-4  w-[1000px] h-[300px]" />
            <p className="font-semibold text-center text-pink-700">She didn’t choose her silence. Society did.</p>
          </CardContent>
        </Card>

        <Card className="rounded-2xl shadow-md">
          <CardContent className="p-6 space-y-4">
            <p className="text-lg">
              One story that changed me was of a young woman abandoned by her husband,
              left with a child, and forced by society into another marriage. That child
              now lives without education or love.
            </p>
             <p className="text-lg">
              <strong>What about these children?</strong> Who will fight for their future?
              Who will give them a chance to learn, grow, and become something more? this is just one story there are 100000 of them no body ever will know !
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <Card className="rounded-2xl shadow-md">
          <CardContent className="p-6 space-y-4">
            <img src={abtimg5} alt="Empty Classroom" className="rounded-lg  w-[1000px] h-[300px]" />
            <p className="font-semibold text-center text-pink-700">Education is not a privilege. It’s a right.</p>
          </CardContent>
        </Card>

        <Card className="rounded-2xl shadow-md">
          <CardContent className="p-6 space-y-4">
            <p className="text-lg">
              I urge everyone reading this to help in whatever way they can. Whether
              through time, skills, donations, or simply sharing these stories—you are
              part of this change.
            </p>
             <p className="text-lg">
              <strong>Let this be a movement.</strong> Let this be the step forward for
              those who never had the chance to take one.
            </p>
          </CardContent>
        </Card>
      </div>

      <div className="text-center space-y-4">
        <p className="text-xl font-medium">
          "To empower a woman is to empower her children, her family, and her community.
          The smartest investment we can make is in women. Women must have the freedom
          and the possibility to decide who they are."
        </p>
        <Button  onClick={() => navigate("/donate")} className="bg-pink-600 hover:bg-pink-700 text-white px-6 py-3 text-lg rounded-2xl">
         
          Be Their Voice
        </Button>
      </div>
    </div>
    </div>
  )
}

export default About